import React, { useContext, useEffect } from "react";
import "./ContactUs.css";
import "./ResponsiveContactUs.css";
import wallpaper from "../../assets/images/contactUs.png";
import { Dropdown, Form } from "react-bootstrap";
import { dataContext } from "../../context/DataContextProviderr";
import { filterKey } from "../../helper/function";
import ScrollAnimation from "react-animate-on-scroll";
import LoadingPage from "../../components/loadingPage/LoadingPage";
const ContactUs = () => {
  const { allWebParts, isLoading } = useContext(dataContext);

  const filterContactUs = allWebParts?.filter(
    (x) => x.uniqueName === "contactUs"
  );

  const filterFooter = allWebParts?.filter(
    (x) => x.uniqueName === "footer-homePage"
  );

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {isLoading ? (
        <LoadingPage />
      ) : (
        <div className="contact-us">
          <div
            className="wallpaper"
            style={{ backgroundImage: `url(${wallpaper})` }}
          >
            <div className="text">
              <p>
                {filterKey(filterContactUs, "title-part1")?.map(
                  (item) => item.Value
                )}{" "}
                <span>
                  {filterKey(filterContactUs, "title-part2")?.map(
                    (item) => item.Value
                  )}
                </span>
              </p>
              <img src="/pic/cloud.png" alt="cloud" />
            </div>
          </div>
          <div className="contactus-detail">
            <ScrollAnimation
              // animateIn="bounceIn"
              animateIn="rotateInUpLeft"
              // animateIn="zoomIn"
              delay={400}
              className="box"
            >
              <img src="/pic/call.png" alt="call-icon" />
              <p>کارخانه - کنترل کیفیت</p>
              <span>
                {filterKey(filterContactUs, "qc-tell-1")?.map(
                  (item) => item.Value
                )}
              </span>
              <span>
                {filterKey(filterContactUs, "qc-tell-2")?.map(
                  (item) => item.Value
                )}
              </span>
              <p>کارخانه - روابط عمومی</p>
              <span>
                {filterKey(filterContactUs, "factory-tell-1")?.map(
                  (item) => item.Value
                )}
              </span>
              <span>
                {filterKey(filterContactUs, "factory-tell-2")?.map(
                  (item) => item.Value
                )}
              </span>
            </ScrollAnimation>
            <ScrollAnimation
              // animateIn="bounceIn"
              animateIn="slideInUp"
              // animateIn="zoomIn"
              delay={400}
              className="box box-center"
            >
              <img src="/pic/location.png" alt="location-icon" />
              <p>دفتر مرکزی</p>
              <span>
                {filterKey(filterContactUs, "centeral-office-address")?.map(
                  (item) => item.Value
                )}
              </span>
              <p>کارخانه</p>
              <span>
                {filterKey(filterContactUs, "factory-address")?.map(
                  (item) => item.Value
                )}
              </span>
            </ScrollAnimation>
            <ScrollAnimation
              // animateIn="bounceIn"
              animateIn="rotateInUpRight"
              // animateIn="zoomIn"
              delay={400}
              className="box"
            >
              <img src="/pic/call.png" alt="call-icon" />
              <p>دفتر مرکزی</p>
              <span>
                {filterKey(filterContactUs, "central-office-tell-1")?.map(
                  (item) => item.Value
                )}
              </span>
              <span>
                {filterKey(filterContactUs, "central-office-tell-2")?.map(
                  (item) => item.Value
                )}
              </span>
              <span>
                {filterKey(filterContactUs, "central-office-tell-3")?.map(
                  (item) => item.Value
                )}
              </span>
              <span>
                {filterKey(filterContactUs, "central-office-tell-4")?.map(
                  (item) => item.Value
                )}
              </span>
              <span>
                {filterKey(filterContactUs, "central-office-tell-5")?.map(
                  (item) => item.Value
                )}
              </span>
              <span>
                {filterKey(filterContactUs, "central-office-tell-6")?.map(
                  (item) => item.Value
                )}
              </span>
            </ScrollAnimation>
            <ScrollAnimation
              // animateIn="bounceIn"
              animateIn="slideInUp"
              // animateIn="zoomIn"
              delay={400}
              className="box box-center mobile"
            >
              <img src="/pic/location.png" alt="location-icon" />
              <p>دفتر مرکزی</p>
              <span>
                {filterKey(filterContactUs, "centeral-office-address")?.map(
                  (item) => item.Value
                )}
              </span>
              <p>کارخانه</p>
              <span>
                {filterKey(filterContactUs, "factory-address")?.map(
                  (item) => item.Value
                )}
              </span>
            </ScrollAnimation>
          </div>

          <div className="form-container">
            <div className="top">
              <p className="p1">
                {" "}
                نظرات و پیشنهادات خود را <span>با ما</span> به اشتراک بگذارید
              </p>
            </div>
            <Form className="form">
              <div className="row">
                <Form.Control type="text" placeholder="نام و نام خانوادگی " />
                <Form.Control type="number" placeholder="شماره موبایل" />
              </div>
              <div className="row">
                <Dropdown className="items">
                  <Dropdown.Toggle>نوع محصول</Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item>خبازی</Dropdown.Item>
                    <Dropdown.Item>صنعتی</Dropdown.Item>
                    <Dropdown.Item>قنادی</Dropdown.Item>
                    <Dropdown.Item>دامپروری</Dropdown.Item>
                    <Dropdown.Item>خوراک دام</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown className="items">
                  <Dropdown.Toggle>نوع پیام ارسالی</Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item>شکایت</Dropdown.Item>
                    <Dropdown.Item>پیشنهاد</Dropdown.Item>
                    <Dropdown.Item>انتقاد</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <div className="textarea-container">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="لطفا پیام خود را تایپ کنید"
                />
              </div>

              <div className="button-container">
                <button> ارسال پیام</button>
              </div>
            </Form>
          </div>

          <ScrollAnimation
            // animateIn="bounceIn"
            // animateIn="slideInUp"
            animateIn="zoomIn"
            delay={400}
            v
            className="shop-container"
          >
            <div className="shop">
              <div className="content">
                <p>سامانه خرید آرد</p>
                <a
                  href={filterKey(filterFooter, "purchase-flour-link")?.map(
                    (item) => item.Value
                  )}
                  target="_blank"
                  rel="noreferrer"
                >
                  Gfloursale.Banksepah.Ir
                </a>
              </div>
            </div>
          </ScrollAnimation>

          <div className="copy-right border-top">
            <p>
              {filterKey(filterFooter, "footer-copyright")?.map(
                (item) => item.Value
              )}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default ContactUs;
